// extracted by mini-css-extract-plugin
export default {"modelPopover":"index_modelPopover__c7OQl","popContent":"index_popContent__RQENl"};